import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { initializeAnalytics, isAnalyticsEnabled } from 'helpers/analytics';
import { Button } from 'react-bootstrap';

const COOKIE_NAME = 'siteops_cookie_consent';
const COOKIE_EXPIRY_DAYS = 365;

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

const setCookie = (name: string, value: string, days: number): void => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};

const CookieConsentBanner = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Only show if analytics is enabled and consent not yet given
    if (isAnalyticsEnabled() && !getCookie(COOKIE_NAME)) {
      setIsVisible(true);
    }
  }, []);

  // Don't render if analytics is disabled or already consented
  if (!isVisible) {
    return null;
  }

  const handleAccept = () => {
    setCookie(COOKIE_NAME, 'true', COOKIE_EXPIRY_DAYS);
    initializeAnalytics();
    setIsVisible(false);
  };

  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 bg-body border-top p-3 d-flex flex-column flex-sm-row align-items-center justify-content-between gap-3"
      style={{ zIndex: 9999 }}
    >
      <span className="text-body">
        {t('cookieConsent.message')}{' '}
        <Link to="/privacy-policy" className="text-primary fw-semibold">
          {t('cookieConsent.learnMore')}
        </Link>
      </span>
      <Button variant="primary" onClick={handleAccept} className="flex-shrink-0">
        {t('cookieConsent.accept')}
      </Button>
    </div>
  );
};

export default CookieConsentBanner;
